module.exports = __webpack_public_path__ + "static/sport/regist.a65c2e0.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport7/regist.gif
// module id = aUmv
// module chunks = 0